import type z from 'zod/v4'
import { relations } from 'drizzle-orm'
import { index, numeric, pgTable, primaryKey, uuid } from 'drizzle-orm/pg-core'
import { createInsertSchema, createSelectSchema, createUpdateSchema } from 'drizzle-zod'

import { SkillWeight } from '../category'
import { Lesson } from './lesson'

export const LessonToSkillWeight = pgTable(
  'lesson_to_skill_weight',
  {
    lessonId: uuid()
      .notNull()
      .references(() => Lesson.id, { onDelete: 'cascade' }),
    skillWeightId: uuid()
      .notNull()
      .references(() => SkillWeight.id, { onDelete: 'cascade' }),
    // The final value of the skill weight (XP Points)
    value: numeric('value', { mode: 'number' }).notNull(),
  },
  (table) => [
    primaryKey({ columns: [table.lessonId, table.skillWeightId] }),
    index('lesson_to_skill_weight_lesson_idx').on(table.lessonId),
    index('lesson_to_skill_weight_skill_weight_idx').on(table.skillWeightId),
  ],
)

export const lessonToSkillWeightRelations = relations(LessonToSkillWeight, ({ one }) => ({
  lesson: one(Lesson, {
    fields: [LessonToSkillWeight.lessonId],
    references: [Lesson.id],
  }),
  skillWeight: one(SkillWeight, {
    fields: [LessonToSkillWeight.skillWeightId],
    references: [SkillWeight.id],
  }),
}))

export const InsertLessonToSkillWeightSchema = createInsertSchema(LessonToSkillWeight)
export const UpdateLessonToSkillWeightSchema = createUpdateSchema(LessonToSkillWeight).partial()
export const SelectLessonToSkillWeightSchema = createSelectSchema(LessonToSkillWeight)

export type InsertLessonToSkillWeight = typeof LessonToSkillWeight.$inferInsert
export type UpdateLessonToSkillWeight = z.infer<typeof UpdateLessonToSkillWeightSchema>
export type SelectLessonToSkillWeight = typeof LessonToSkillWeight.$inferSelect
